import { ShippingClaimSchema } from "@redotech/redo-package-protection-common/shipping-claims/shipping-claim";
import * as z from "zod";

export const getMerchantShippingClaim = {
  name: "getMerchantShippingClaim" as const,
  input: z.object({ claimId: z.string() }),
  output: ShippingClaimSchema,
};
